import React from "react";
import { SummaryImageProps } from "../../../interfaces";
import "./SummaryImage.scss";

const SummaryImage = (props: SummaryImageProps) => {
  return (
    <React.Fragment>
      <div className= {props.customClass!==null && typeof(props.customClass)!=="undefined"? props.customClass : "imageContainer"}>
        <img
          alt={props.alt}
          src={window.location.origin + "/images/" + props.url}
          height={props.height}
          width={props.width}
        />
      </div>
    </React.Fragment>
  );
};

export default SummaryImage;
